import React from 'react';
import { connect } from 'react-redux';
import withProducts from '../Products';
import {
  toggleProduct,
  toggleCategory,
  changeProductQuantity,
  setCategories,
  setMenuData,
  clearProductsSelected,
  clearNewMenuCategories,
} from '../../store/actions';
import { isUhuuMtkpc } from '../../helpers/uhuu';

function withCreateMenu(WrappedComponent) {
  const mapStateToProps = state => ({
    newMenu: state.newMenu,
  });

  const mapDispatchToProps = dispatch => ({
    toggleProduct: (categoryId, productId) => dispatch(toggleProduct(categoryId, productId)),
    toggleCategory: categoryId => dispatch(toggleCategory(categoryId)),
    clearProductsSelected: () => dispatch(clearProductsSelected()),
    clearNewMenuCategories: () => dispatch(clearNewMenuCategories()),
    changeQuantity: (categoryId, productId, quantity) =>
      dispatch(changeProductQuantity(categoryId, productId, quantity)),
    setCategories: categories => dispatch(setCategories(categories)),
    setMenuData: menu => dispatch(setMenuData(menu)),
  });

  const handleChangeQuantity = ({ categoryId, productId, event, changeQuantity, quantity }) => {
    if (isNumberValid(event)) {
      changeQuantity(categoryId, productId, event.target.value);
    } else {
      changeQuantity(categoryId, productId, quantity || 0);
    }
  };

  const isNumberValid = e => {
    const value = e.target.value;
    const validRegex = new RegExp(/^[0-9]+$/);
    if (!value || validRegex.test(value)) {
      return true;
    }
    e.preventDefault();
    return false;
  };

  const CreateMenuContainer = props => {
    const { newMenu, changeQuantity } = props; // eslint-disable-line
    return (
      <WrappedComponent
        {...props}
        isUhuuMtkpc={() =>
          isUhuuMtkpc(
            newMenu.menu && Object.keys(newMenu.menu).length ? newMenu.menu.marketplaces : []
          )
        }
        handleChangeQuantity={(categoryId, productId, event, quantity) =>
          handleChangeQuantity({
            categoryId,
            productId,
            event,
            quantity,
            changeQuantity,
          })
        }
      />
    );
  };

  const CreateContainer = connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateMenuContainer);
  return withProducts(CreateContainer);
}

export default withCreateMenu;



// WEBPACK FOOTER //
// ./src/containers/CreateMenu/index.js